import React from 'react';

export const NoResults = () => {
  return (
    <div className="flex flex-col gap-6 md:px-4">
      <div className="flex flex-col items-center gap-1 pb-40 pt-52">
        <p className="text-title text-center text-title-s font-medium md:text-title-m">
          No results found
        </p>
        <p className="font-base text-base-xs md:text-base-m">
          If at first you don't succeed, try again.
        </p>
      </div>
    </div>
  );
};
